import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
/**
 * API | Get all flags
 * @param dispatch
 * @param commit
 * @returns {*}
 */
export function getFlags(_ref) {
  var dispatch = _ref.dispatch,
    commit = _ref.commit;
  return dispatch('api', {
    url: 'flags'
  }, {
    root: true
  }).then(function (response) {
    if (response !== null && response !== void 0 && response.data) {
      commit('SET_FLAGS', response.data.data);
    }
  }).catch(function (error) {
    return Promise.reject(error);
  });
}